export default __webpack_public_path__ + "static/media/sph.2ee6168e.png";